// General + per-service FAQs.

export const GENERAL_FAQ = [
  {
    q: 'What types of businesses do you work with?',
    a: 'Service-based businesses — cleaning, home services, property care, wellness, coaching, agencies, and local professional firms. The common thread is owner-led businesses that want to operate more reliably as they grow.',
  },
  {
    q: 'Do you only work with cleaning companies?',
    a: 'No. Cleaning companies are a natural fit because their operations are scheduling- and team-heavy, but I work across many service industries. The principles of clear systems, dependable communication, and a strong customer experience translate to any service business.',
  },
  {
    q: 'Can you work with existing teams?',
    a: 'Yes — most of my engagements involve working alongside an existing team. I plug into your tools, learn your processes, and bring structure without replacing the people who already know your business.',
  },
  {
    q: 'Do you provide ongoing support?',
    a: 'Yes. Many clients move from a one-off project into a continuing operations partnership. The scope, hours, and rhythm are agreed in writing so expectations stay clear.',
  },
  {
    q: 'How do projects get started?',
    a: 'It starts with a discovery call — a short, focused conversation about your business. From there I share a written recommendation and proposal. If we move forward, onboarding typically begins within one to two weeks.',
  },
  {
    q: 'Do you offer custom solutions?',
    a: 'Every engagement is shaped around the business. I do not use one-size-fits-all packages. The work is scoped after I understand what you need and what is going to actually move the business forward.',
  },
];

export const WEBSITE_FAQ = [
  { q: 'How long does a website project take?', a: 'Most websites are delivered within four to six weeks from kick-off, depending on scope and content readiness.' },
  { q: 'Do you provide hosting?', a: 'I help you choose the right hosting for the platform we build on. Hosting is set up as part of the engagement, with clear ownership transferred to you.' },
  { q: 'Can you redesign an existing website?', a: 'Yes. We start with a short audit of the current site, then either refresh what is working or rebuild what is not — whichever serves the business best.' },
  { q: 'Will my website be mobile friendly?', a: 'Yes. Every website is built mobile-first and tested across phones, tablets and desktop before launch.' },
];

export const SEO_FAQ = [
  { q: 'How long does SEO take?', a: 'Local SEO improvements often begin to show within 60 to 90 days. Broader organic growth tends to compound over six to twelve months.' },
  { q: 'What is local SEO?', a: 'Local SEO is the set of practices that help your business show up in Google Search and Google Maps when nearby customers search for the services you offer.' },
  { q: 'Do you optimise Google Business Profiles?', a: 'Yes. Google Business Profile optimisation is part of every local SEO engagement — including categories, services, photos, posts and review strategy.' },
  { q: 'Do you provide reporting?', a: 'Yes. A clear monthly report covers rankings, search visibility, traffic, and the next set of priorities — written so a non-technical owner can follow it.' },
];

export const SOCIAL_FAQ = [
  { q: 'What platforms do you manage?', a: 'Most commonly Instagram, Facebook, LinkedIn and TikTok. We focus on the platforms where your audience already pays attention.' },
  { q: 'Do you create content?', a: 'Yes — design, copy and short-form video editing are part of every social engagement.' },
  { q: 'Do you respond to reviews?', a: 'Yes. Review management — including thoughtful, brand-appropriate responses to both positive and difficult reviews — is available as part of the engagement.' },
  { q: 'How often do you post?', a: 'Posting frequency is set during onboarding based on your goals. A common rhythm is three to five posts per week on a primary platform, with stories and short videos layered in.' },
];

export const VIRTUAL_SUPPORT_FAQ = [
  { q: 'Is this a virtual assistant service?', a: 'No. I work as an Operations & Systems Specialist. The support is delivered with ownership and accountability — focused on outcomes, not just task completion.' },
  { q: 'Do you work with my existing tools?', a: 'Yes. I work inside the tools your team already uses. If a change would clearly help the business, I will explain why and let you decide.' },
  { q: 'What kinds of businesses do you support?', a: 'Service-based businesses — cleaning, home services, property care, wellness, and similar local service brands.' },
  { q: 'How quickly can we start?', a: 'Most engagements begin within one to two weeks of the discovery call, depending on scope.' },
];

export const SERVICE_FAQ_MAP = {
  'virtual-support': VIRTUAL_SUPPORT_FAQ,
  'website-design': WEBSITE_FAQ,
  'seo-optimization': SEO_FAQ,
  'social-media-management': SOCIAL_FAQ,
};
